import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLocalization } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import {
  AddLocalization,
  AddLocalizationResponse,
} from "src/Pages/Company/OrganizationStructure/Localizations/localizations.models";

const useCreateLocalization = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation<AddLocalizationResponse, Error, AddLocalization>({
    mutationFn: async (formData) =>
      createLocalization({
        companyId,
        structureId,
        formData,
      }),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie dodano lokalizację"), "success");

      queryClient.invalidateQueries({
        queryKey: ["localizations-list", companyId, structureId],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się dodać lokalizacji"), "error");
    },
  });
};

export default useCreateLocalization;
